import React from 'react';

import copy from './i18n/sv.json';

const ArrayField = ({ label, values, onAdd, onRemove, onChange, placeholder }) => {
    const strings = copy.createSiteAdmin.arrayField;

    return (
        <div className="array-card">
            <div className="array-card-header">
                <div>
                    <p className="array-card-title">{label}</p>
                    <p className="array-card-text">{strings.description}</p>
                </div>

                <button
                    type="button"
                    onClick={onAdd}
                    className="button button--secondary"
                >
                    {strings.add}
                </button>
            </div>

            <div className="array-card-list">
                {values.map((value, index) => (
                    <div key={index} className="array-row">
                        <input
                            className="form-input"
                            value={value}
                            placeholder={placeholder}
                            onChange={(e) => onChange(index, e.target.value)}
                        />
                        <button
                            type="button"
                            onClick={() => onRemove(index)}
                            disabled={values.length === 1}
                            className="button button--secondary"
                        >
                            {strings.remove}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ArrayField;
